/**
 * データ構造
 * @return {
 *  authenticity_token: string,
 *  thanks_page_url: string,
 *  submit_form_url: string,
 *  m3_login_url: string,
 *  device: string,
 *  is_processing: boolean
 * }
 */
const state = {
  authenticity_token: undefined,
  thanks_page_url: undefined,
  submit_form_url: undefined,
  m3_login_url: undefined,
  device: undefined,
  is_processing: false,
  is_submitted: false
};

const actions = {
  initData({ dispatch }, request_params){
    dispatch('setAuthenticityToken', request_params.authenticity_token);
    dispatch('setThanksPageUrl', request_params.thanks_page_url);
    dispatch('setSubmitFormUrl', request_params.submit_form_url);
    dispatch('setM3LoginUrl', request_params.m3_login_url);
    dispatch('setDevice', request_params.device);
  },
  setAuthenticityToken({ commit }, authenticity_token){
    commit('SET_AUTHENTICITY_TOKEN', authenticity_token);
  },
  setThanksPageUrl({ commit }, thanks_page_url){
    commit('SET_THANKS_PAGE_URL', thanks_page_url);
  },
  setSubmitFormUrl({ commit }, submit_form_url){
    commit('SET_SUBMIT_FORM_URL', submit_form_url);
  },
  setM3LoginUrl({ commit }, m3_login_url){
    commit('SET_M3_LOGIN_URL', m3_login_url);
  },
  setDevice({ commit }, device){
    commit('SET_DEVICE', device);
  },
  setIsProcessing({ commit }, is_processing){
    commit('SET_IS_PROCESSING', is_processing);
  },
};

const getters = {
};

const mutations = {
  SET_AUTHENTICITY_TOKEN(state, value){
    state.authenticity_token = value;
  },
  SET_THANKS_PAGE_URL(state, value){
    state.thanks_page_url = value;
  },
  SET_SUBMIT_FORM_URL(state, value){
    state.submit_form_url = value;
  },
  SET_M3_LOGIN_URL(state, value){
    state.m3_login_url = value;
  },
  SET_DEVICE(state, value){
    state.device = value;
  },
  SET_IS_PROCESSING(state, value){
    state.is_processing = value;
  },
  SET_IS_SUBMITTED(state, value){
    state.is_submitted = value;
  }
};

export default {
  namespaced: true,
  state: () => state,
  getters,
  actions,
  mutations
};